import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetPaymentMethodsMutation } from '../apis';
import type { PaymentMethodQueryLinkerSchema } from '../schemas';

export function PaymentMethodsSelect({ disabled, ...props }: FormAsyncComboboxProps<PaymentMethodQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: PaymentMethodQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/payment-methods/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetPaymentMethodsMutation}
      disabled={disabled}
    />
  );
}
